import React, { useEffect } from 'react';
import { Container, Table } from 'reactstrap';
import { formatDate } from '../../helper';
import { connect } from 'react-redux';
import axios from 'axios';
import { isFunction } from 'lodash';
import { Link } from 'react-router-dom';
import { Loading } from '../../components';

const statusMap = {
  PROCESSING: 'Đang diễn ra',
  COMPLETED: 'Đã kết thúc',
  WAITING_APPROVAL: 'Đang chờ chốt',
};

export const ContestListPage = ({ data, onMount }) => {
  useEffect(() => {
    if (isFunction(onMount)) onMount();
  }, []);

  const renderContestList = () => {
    if (data === null) return <Loading />;
    if (data?.length > 0)
      return (
        <Table>
          <thead>
            <tr>
              <th>Tên thi đua</th>
              <th>Mã Memo</th>
              <th>Ngày bắt đầu</th>
              <th>Ngày kết thúc</th>
              <th>Ngày đóng</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((d) => (
              <tr key={d.id}>
                <td>
                  <Link to={`/contest/${d.id}`}>{d.name}</Link>
                </td>
                <td>{d.memoId}</td>
                <td>{formatDate(d.startDate)}</td>
                <td>{formatDate(d.endDate)}</td>
                <td>{formatDate(d.closeDate)}</td>
                <td>{statusMap?.[d.status] || d.status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    return (
      <p className='font-weight-bold'>
        Tìm thấy <span className='text-primary'>0</span> chương trình thi đua
      </p>
    );
  };

  return (
    <Container fluid className='pt-3 px-lg-5'>
      <div>
        <span className='text-primary h2 text-uppercase'>Danh sách chương trình thi đua</span>
      </div>
      <div className='pt-3'>{renderContestList()}</div>
    </Container>
  );
};

export const FETCH_CONTEST_LIST_START = 'FETCH_CONTEST_LIST_START';
export const FETCH_CONTEST_LIST_SUCCESS = 'FETCH_CONTEST_LIST_SUCCESS';
export const FETCH_CONTEST_LIST_ERROR = 'FETCH_CONTEST_LIST_ERROR';

export const loadContextList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CONTEST_LIST_START });
    let res = await axios.get('/api/contests');
    let payload = res?.data?.content;
    dispatch({ type: FETCH_CONTEST_LIST_SUCCESS, payload });
  } catch (err) {
    dispatch({ type: FETCH_CONTEST_LIST_ERROR });
  }
};

const mapStateToProps = (state) => {
  const data = state?.contest.data;
  return { data };
};

const mapDispatchToProps = { onMount: loadContextList };

export default connect(mapStateToProps, mapDispatchToProps)(ContestListPage);
